export default __webpack_public_path__ + "static/media/score_student_image.d9ef6016.jpg";